import { FormEvent, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/stores/authStore";

export default function RegisterPage() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    full_name: "",
    email: "",
    password: "",
    phone: "",
    street: "",
    zip: "",
    city: "",
    delivery_notes: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      const res = await fetch("/api/konten?action=register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error ?? "Registrierung fehlgeschlagen");
        return;
      }
      const r = await signIn(form.email, form.password);
      if (r.error) {
        setError(`Konto angelegt, Login fehlgeschlagen: ${r.error}`);
        return;
      }
      navigate("/shop", { replace: true });
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setSubmitting(false);
    }
  }

  const setField = (k: keyof typeof form, v: string) => setForm((f) => ({ ...f, [k]: v }));

  return (
    <div
      style={{ height: "calc(100% - var(--tastatur, 0px))" }}
      className="grid place-items-center overflow-y-auto bg-gradient-to-b from-hof-50 to-wiese-50 px-4 py-8"
    >
      <form onSubmit={onSubmit} className="card w-full max-w-lg space-y-4">
        <div className="text-center space-y-2">
          <img src="/logo-emblem.png" alt="Hof Sirges" className="h-24 mx-auto" />
          <div className="font-brand text-2xl text-wappen-700">Konto anlegen</div>
          <div className="text-hof-600 text-sm">Wenige Schritte und Sie können bestellen.</div>
        </div>

        <div>
          <label className="label">Vor- und Nachname *</label>
          <input className="input" value={form.full_name} onChange={(e) => setField("full_name", e.target.value)} required autoComplete="name" />
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div>
            <label className="label">E-Mail *</label>
            <input className="input" type="email" value={form.email} onChange={(e) => setField("email", e.target.value)} required autoComplete="email" />
          </div>
          <div>
            <label className="label">Telefon</label>
            <input className="input" type="tel" value={form.phone} onChange={(e) => setField("phone", e.target.value)} autoComplete="tel" />
          </div>
        </div>
        <div>
          <label className="label">Passwort * <span className="text-xs text-hof-500">(min 8 Zeichen)</span></label>
          <input className="input" type="password" value={form.password} onChange={(e) => setField("password", e.target.value)} required minLength={8} autoComplete="new-password" />
        </div>

        <hr className="border-hof-100" />
        <div className="text-sm font-medium text-hof-700">Lieferadresse</div>

        <div>
          <label className="label">Strasse + Hausnr *</label>
          <input className="input" value={form.street} onChange={(e) => setField("street", e.target.value)} required autoComplete="street-address" />
        </div>
        <div className="grid grid-cols-[1fr_2fr] gap-3">
          <div>
            <label className="label">PLZ *</label>
            <input className="input" inputMode="numeric" value={form.zip} onChange={(e) => setField("zip", e.target.value)} required autoComplete="postal-code" />
          </div>
          <div>
            <label className="label">Ort *</label>
            <input className="input" value={form.city} onChange={(e) => setField("city", e.target.value)} required autoComplete="address-level2" />
          </div>
        </div>
        <div>
          <label className="label">Lieferhinweis (optional)</label>
          <input className="input" value={form.delivery_notes} onChange={(e) => setField("delivery_notes", e.target.value)} placeholder="z.B. Hintereingang, Code 1234" />
        </div>

        {error && (
          <div className="rounded-xl bg-red-50 border border-red-200 px-4 py-3 text-red-800 text-sm">{error}</div>
        )}

        <button type="submit" className="btn-primary w-full" disabled={submitting}>
          {submitting ? "Anlegen…" : "Konto anlegen & bestellen"}
        </button>
        <div className="text-center text-sm text-hof-600">
          Schon Kunde? <Link to="/login" className="text-wiese-700 underline">Anmelden</Link>
        </div>
        <div className="text-center text-xs text-hof-500">
          Wir liefern im Umkreis von 100 km um Versmold.
        </div>
      </form>
    </div>
  );
}
